// Version : 1.0.0
// Author : AGALYA
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** CO-APPLICANT UPDATE START *********************** */
export const coApplicantUpdate = (updateCoApplicantData: any) => {
	const data = {
		CoApplicantToken: updateCoApplicantData,
	};
	const url = `${API_URL}updateCoApplicant`;
	return makeApiCall(url, data);
};
/** ***************** CO-APPLICANT UPDATE END *********************** */

/** ***************** CO-APPLICANT ADD START *********************** */
export const coApplicantAdd = (updateCoApplicantData: any) => {
	const data = {
		CoApplicantToken: updateCoApplicantData,
	};
	const url = `${API_URL}addCoBorrower`;
	return makeApiCall(url, data);
};
/** ***************** CO-APPLICANT ADD END *********************** */

/** ***************** CO-APPLICANT FETCH START *********************** */
export const coApplicantFetch = (updateCoApplicantData: any) => {
	const data = {
		FetchMemberDetailsToken: updateCoApplicantData,
	};
	const url = `${API_URL}fetchParticularCoApplicant`;
	return makeApiCall(url, data);
};
/** ***************** CO-APPLICANT FETCH END *********************** */

/** ***************** CO-APPLICANT DELETE START *********************** */
export const coApplicantDelete = (CoApplicantData: any) => {
	const data = {
		DeleteCoApplicantToken: CoApplicantData,
	};
	const url = `${API_URL}deleteParticularCoApplicant`;
	return makeApiCall(url, data);
};
/** ***************** CO-APPLICANT DELETE END *********************** */

/** ***************** CO-APPLICANT HIGHMARK / CRIF CHECK START *********************** */
export const coApplicantCrifAPI = (CoApplicantData: any) => {
	const data = {
		CheckCoAppliantHighMarkToken: CoApplicantData,
	};
	const url = `${API_URL}callCoApplicantHighMark`;
	return makeApiCall(url, data);
};
/** ***************** CO-APPLICANT HIGHMARK / CRIF CHECK END *********************** */

/** ***************** VERIFY CO-APPLICANT AADHAAR OTP START *********************** */
export const verifyCoApplicantAadharOtpAPI = (credentials: any, serviceName: string) => {
	const data = {
		AadharOtpVerificationToken: credentials,
	};
	const url = `${API_URL + serviceName}`;
	return makeApiCall(url, data);
};
/** ***************** VERIFY CO-APPLICANT AADHAAR OTP END *********************** */

/** ***************** VALIDATE CO-APPLICANT AADHAAR OTP START *********************** */
export const verifyValidateCoApplicantAadharOtpAPI = (credentials: any, serviceName: string) => {
	const data = {
		AadharValidateOtpVerificationToken: credentials,
	};
	const url = `${API_URL + serviceName}`;
	return makeApiCall(url, data);
};
/** ***************** VALIDATE CO-APPLICANT AADHAAR OTP END *********************** */
